<template>
  <div v-if="data.class === 'rangeslider'">
    <v-slider
      v-model="data.value"
      thumb-label
      :label="data.text"
      :hint="data.placeholder"
      persistent-hint
      :hide-details="!(!!data.placeholder)"
    ></v-slider>
  </div>
  <div v-else-if="data.class === 'vertical'">
    <v-slider
      v-model="data.value"
      thumb-label
      vertical
      :label="data.text"
      :hint="data.placeholder"
      persistent-hint
      :hide-details="!(!!data.placeholder)"
    ></v-slider>
  </div>
</template>

<script>
export default {
  name: "RangeSlider",
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};
</script>

<style>
</style>